var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"title":_vm.$t('doctordata.doctordata'),"showButtonReturn":true,"showButtonHome":true}},[_c('DoctorDataForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }